import { Flex, Icon } from "orcs-design-system";
import PropTypes from "prop-types";
import { Fragment } from "react";
import TeamLink from "src/components/TeamLink";
import { getGroupNamesArrayFromHierarchy } from "src/util/group";

// Render the full ancestor breadcrumb for the previous parent when the
// hierarchy string and id array agree on length. If they don't (or either is
// missing), fall back to a single TeamLink for the previous parent itself
// rather than risk rendering a misleading breadcrumb.
const PreviousLocationBreadcrumb = ({ group }) => {
  const labels = getGroupNamesArrayFromHierarchy(group.hierarchy);
  const ids = group.hierarchyIds;

  if (!ids?.length || labels.length !== ids.length) {
    return <TeamLink bold team={group} />;
  }

  return (
    <Flex alignItems="center" flexWrap="wrap" gap="xs">
      {ids.map((id, index) => (
        <Fragment key={id}>
          {index > 0 && (
            <Icon
              icon={["fas", "chevron-right"]}
              color="grey"
              size="xs"
              aria-hidden
            />
          )}
          <TeamLink
            bold
            small
            noWrap={false}
            team={{ id }}
            teamName={labels[index]}
          />
        </Fragment>
      ))}
    </Flex>
  );
};

PreviousLocationBreadcrumb.propTypes = {
  group: PropTypes.object.isRequired,
};

export default PreviousLocationBreadcrumb;
